import { useEffect, useState } from "react";
//API
import { axiosWithAuth } from "../../../../api/axiosConfig";
import { urlEventos } from "../../../../api/URLs/correos";
//HOOKS
import { useModal } from "../../../../hooks/useModal";
//FORM
import FormEvento from "../forms/FormEvento";
//COMPONENTS
//--modal
import ModalAlert from "../../../../components/Modals/ModalAlert";
import ModalPlain from "../../../../components/Modals/ModalPlain";
//--table
import Table from "../../../../components/Tools/Tables/Table/Table";
import BoxContainer from "../../../../components/Tools/Cards/BoxContainer/BoxContainer";
//--basic
import CustomBtn from "../../../../components/Tools/Basics/CustomBtn";

const TableEventos = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reFetch, setReFetch] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModalPlain, setShowModalPlain] = useState(false);
  const handleCloseModalPlain = () => setShowModalPlain(false);
  //useModal
  const { handleError, showModal, modalType, msjModal, handleClose } =
    useModal();
  const handleEvents = (event) => {
    if (event) {
      setSelectedEvent(event);
    } else {
      setSelectedEvent(null);
    }
    setShowModalPlain(true);
  };
  //COLUMNAS
  const actionButton = (event) => {
    return (
      <CustomBtn type={"edit_table"} onClick={() => handleEvents(event)} />
    );
  };
  const columns = [
    { field: "id", header: "Id" },
    { field: "evento", header: "Evento" },
    { body: actionButton },
  ];
  const buttons = [
    {
      type: "plus_table_header",
      click: () => handleEvents(),
      noData: true,
    },
  ];
  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const api_response = await axiosWithAuth.get(urlEventos);
        setData(api_response.data);
      } catch (error) {
        const auxError = error.response.data.msj
          ? error.response.data.msj
          : "Error del servidor";
        handleError(auxError);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [reFetch]);
  return (
    <div>
      <BoxContainer maxSize={"sm"} minSize={"sm"}>
        <Table
          data={data}
          columns={columns}
          buttons={buttons}
          loading={loading}
          title={"Eventos"}
          scrollSize={"sm"}
          textFilter
        />
      </BoxContainer>
      <ModalAlert
        show={showModal}
        type={modalType}
        msj={msjModal}
        handleClose={handleClose}
      />
      {showModalPlain ? (
        <ModalPlain show={true} handleClose={handleCloseModalPlain}>
          <FormEvento
            event={selectedEvent}
            reFetch={reFetch}
            setReFetch={setReFetch}
          />
        </ModalPlain>
      ) : null}
    </div>
  );
};

export default TableEventos;
